// extracted by mini-css-extract-plugin
export default {"header":"ConfiguredDocumentInputGroupHeader_header__ghmPZ"};